// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host::ng-deep .dropdown-menu {
  padding-top: 0;
  padding-bottom: 0;
}
:host::ng-deep .btn-sm {
  padding: 0;
}
:host::ng-deep .btn-sm i-feather .feather {
  height: 0.875rem;
  width: 0.875rem;
}
:host::ng-deep .btn-sm .btn {
  padding: 1rem;
}
:host::ng-deep .btn-sm .btn .dropdown-trigger {
  display: flex;
  align-items: center;
}
:host::ng-deep .ngb-dp-header {
  padding-top: 0.5rem;
}
:host::ng-deep .ngb-dp-months {
  flex-direction: column;
}
@media (min-width: 1200px) {
  :host::ng-deep .ngb-dp-months {
    flex-direction: row;
  }
}
:host::ng-deep .ngb-dp-navigation-select .custom-select {
  margin: 0 0.25rem;
  background-position: right 0.5rem center;
}
:host::ng-deep .ngb-dp-weekday {
  font-size: 0.75rem;
  color: #4a515b;
  font-weight: 700;
  font-style: normal;
}
:host::ng-deep .ngb-dp-month-name {
  color: #4a515b;
  font-weight: 700;
  margin-top: 0.5rem;
  height: 1rem;
  line-height: 1rem;
}
:host::ng-deep .ngb-dp-header,
:host::ng-deep .ngb-dp-weekdays,
:host::ng-deep .ngb-dp-month-name {
  background-color: transparent;
}
:host::ng-deep .ngb-dp-month-name {
  font-size: 0.75rem;
}

.items {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.items .dropdown-item {
  font-size: 0.75rem;
  padding: 0.5rem 0.75rem;
  color: #4a515b;
}

.calendar-container {
  background-color: transparent;
  padding: 0.5rem;
}

.form-group.hidden {
  width: 0;
  margin: 0;
  border: none;
  padding: 0;
}

.range-picker {
  border-left: 1px solid #e0e5ec;
}
.range-picker ngb-datepicker {
  border: none;
}
.range-picker .custom-day {
  padding: 1px;
  font-size: 0.75rem;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 1.6875rem;
  width: 2rem;
  white-space: nowrap;
  border-radius: 3px;
}
.range-picker .custom-day:hover {
  background-color: #1da1f5;
  color: white;
}
.range-picker .custom-day.range {
  background-color: #1da1f5;
  color: white;
  border-radius: 0;
}
.range-picker .custom-day.focused {
  background-color: #1da1f5;
}
.range-picker .custom-day.faded {
  background-color: #e8f6fe;
  color: #4a515b;
}`, "",{"version":3,"sources":["webpack://./src/modules/app-common/components/date-range-quick/date-range-quick.component.scss","webpack://./src/styles/core/variables/_colors.scss","webpack://./src/styles/_variables-overrides.scss"],"names":[],"mappings":"AAGI;EACI,cAAA;EACA,iBAAA;AAFR;AAKI;EACI,UAAA;AAHR;AAKQ;EACI,gBAAA;EACA,eAAA;AAHZ;AAMQ;EACI,aAAA;AAJZ;AAMY;EACI,aAAA;EACA,mBAAA;AAJhB;AASI;EACI,mBAAA;AAPR;AAUI;EACI,sBAAA;AARR;AASQ;EAFJ;IAGQ,mBAAA;EANV;AACF;AAUQ;EACI,iBAAA;EACA,wCAAA;AARZ;AAYI;EACI,kBAAA;EACA,cCfG;EDgBH,gBAAA;EACA,kBAAA;AAVR;AAaI;EACI,cCrBG;EDsBH,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAXR;AAcI;;;EAGI,6BAAA;AAZR;AAgBI;EACI,kBAAA;AAdR;;AAkBA;EACI,mBAAA;EACA,sBAAA;AAfJ;AAgBI;EACI,kBAAA;EACA,uBAAA;EACA,cC9CG;ADgCX;;AAkBA;EACI,6BAAA;EACA,eAAA;AAfJ;;AAkBA;EACI,QAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;AAfJ;;AAkBA;EACI,8BAAA;AAfJ;AAiBI;EACI,YAAA;AAfR;AAkBI;EACI,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AAhBR;AAkBQ;EACI,yBErGF;EFsGE,YAAA;AAhBZ;AAmBQ;EACI,yBE1GF;EF2GE,YAAA;EACA,gBAAA;AAjBZ;AAoBQ;EACI,yBEhHF;AF8FV;AAqBQ;EACI,yBAAA;EACA,cClGD;AD+EX","sourcesContent":["@import 'styles/core/variables.scss';\n\n:host::ng-deep {\n    .dropdown-menu {\n        padding-top: 0;\n        padding-bottom: 0;\n    }\n\n    .btn-sm {\n        padding: 0;\n\n        i-feather .feather {\n            height: 0.875rem;\n            width: 0.875rem;\n        }\n\n        .btn {\n            padding: 1rem;\n\n            .dropdown-trigger {\n                display: flex;\n                align-items: center;\n            }\n        }\n    }\n\n    .ngb-dp-header {\n        padding-top: 0.5rem;\n    }\n\n    .ngb-dp-months {\n        flex-direction: column;\n        @media(min-width: 1200px) {\n            flex-direction: row;\n        }\n    }\n\n    .ngb-dp-navigation-select {\n        .custom-select {\n            margin: 0 0.25rem;\n            background-position: right 0.5rem center;\n        }\n    }\n\n    .ngb-dp-weekday {\n        font-size: 0.75rem;\n        color: $gray-700;\n        font-weight: 700;\n        font-style: normal;\n    }\n\n    .ngb-dp-month-name {\n        color: $gray-700;\n        font-weight: 700;\n        margin-top: 0.5rem;\n        height: 1rem;\n        line-height: 1rem;\n    }\n\n    .ngb-dp-header,\n    .ngb-dp-weekdays,\n    .ngb-dp-month-name {\n        background-color: transparent;\n\n    }\n\n    .ngb-dp-month-name {\n        font-size: 0.75rem;\n    }\n}\n\n.items {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n    .dropdown-item {\n        font-size: 0.75rem;\n        padding: 0.5rem 0.75rem;\n        color: $gray-700;\n    }\n}\n\n.calendar-container {\n    background-color: transparent;\n    padding: 0.5rem;\n}\n\n.form-group.hidden {\n    width: 0;\n    margin: 0;\n    border: none;\n    padding: 0;\n}\n\n.range-picker {\n    border-left: 1px solid $border-color;\n\n    ngb-datepicker {\n        border: none;\n    }\n\n    .custom-day {\n        padding: 1px;\n        font-size: 0.75rem;\n        text-align: center;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        height: 1.6875rem;\n        width: 2rem;\n        white-space: nowrap;\n        border-radius: 3px;\n\n        &:hover {\n            background-color: $primary;\n            color: white;\n        }\n\n        &.range {\n            background-color: $primary;\n            color: white;\n            border-radius: 0;\n        }\n\n        &.focused {\n            background-color: $primary;\n        }\n\n        &.faded {\n            background-color: mix($white, $primary, 90%);\n            color: $gray-700;\n        }\n    }\n}\n","// Override Bootstrap color system\n\n$red: #e81500;\n$orange: #f76400;\n$yellow: #f4a100;\n$green: #00ac69;\n$teal: #00ba94;\n$cyan: #00cfd5;\n$blue: #0061f2;\n$indigo: #5800e8;\n$purple: #6900c7;\n$pink: #e30059;\n\n// Custom grayscale base hue variable\n//\n// Changing this to adjusts the hue of the grayscale\n\n$grayscale-base-hue: $blue;\n\n// Override Bootstrap grayscale with custom adaptive grayscale\n//\n// Mixes the $grayscale-base-hue variable with a desaturated\n// black and white grayscale to produce a grayscale with slight color saturation\n\n$white: #fff;\n$gray-100: mix(#fcfcfc, $grayscale-base-hue, 96%);\n$gray-200: mix(#ececec, $grayscale-base-hue, 95%);\n$gray-300: mix(#e2e2e2, $grayscale-base-hue, 94%);\n$gray-400: mix(#d4d4d4, $grayscale-base-hue, 93%);\n$gray-500: mix(#b4b4b4, $grayscale-base-hue, 93%);\n$gray-600: mix(#717171, $grayscale-base-hue, 93%);\n$gray-700: mix(#505050, $grayscale-base-hue, 93%);\n$gray-800: mix(#3a3a3a, $grayscale-base-hue, 93%);\n$gray-900: mix(#242424, $grayscale-base-hue, 93%);\n$black: #000;\n\n// Override Bootstrap default state colors\n\n$primary: $blue;\n$secondary: $purple;\n$success: $green;\n$info: $cyan;\n$warning: $yellow;\n$danger: $red;\n$dark: $gray-900;\n$light: $gray-100;\n\n// Brand color variables\n//\n// Used to create custom button styles for popular brands\n// You can add more brand color variables below, a good place to\n// find official brand colors is https://brandcolors.net/\n\n$facebook: #3b5998;\n$twitter: #1da1f2;\n$github: #333333;\n$google: #ea4335;","//\n// Variable overrides\n//\n\n// This file is intentionally blank\n// Use this file to override any core SCSS variables\n\n// This file was generated for Start Bootstrap Admin Pro Angular\n// https://startbootstrap.com/theme/sb-admin-pro-angular\n// https://sb-admin-pro-angular.startbootstrap.com/dashboard\n// Place this file in src/styles/sb-admin-pro/_variables-colors-overrides.scss\n\n$primary: #1da1f5;\n$secondary: #8039da;\n$success: #12ac70;\n$danger: #e83d2c;\n$warning: #ffc147;\n$info: #2ccfd4;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
